/**
 * WordPress Dependencies
 */
import { __ } from '@wordpress/i18n';
import { select } from '@wordpress/data';
import { addFilter } from '@wordpress/hooks';
import { useEffect } from '@wordpress/element';
import { assign, isEmpty, uniqueId } from 'lodash';
import { createHigherOrderComponent } from '@wordpress/compose';

/**
 * Add new attributes to the block
 */
const addAttributes = ( props ) => {
	if ( isEmpty( props.attributes ) || props.name !== 'core/query' ) {
		return props;
	}
	props.attributes = assign(
		props.attributes,
		{
			...props.attributes,
			ghubQueryId: {
				type: 'string',
				default: '',
			},
		},
		{}
	);

	return props;
};

const withAdvanceControls = createHigherOrderComponent( ( BlockEdit ) => {
	return ( props ) => {
		const { name } = props;

		if ( name !== 'core/query' ) {
			return <BlockEdit { ...props } />;
		}
		useEffect( () => {
			const blocks = select( 'core/block-editor' ).getBlocks();

			blocks.forEach( ( block ) => {
				if ( block.name === 'core/query' ) {
					const queryId = block.attributes.ghubQueryId;
					const shouldSetQueryId =
						props.attributes.ghubQueryId === queryId ||
						isEmpty( props.attributes.ghubQueryId );

					if ( shouldSetQueryId ) {
						props.setAttributes( {
							ghubQueryId: uniqueId(),
						} );
					}
				}
			} );
		}, [] );

		return <BlockEdit { ...props } />;
	};
}, 'withAdvanceControls' );

const withBlockWrapper = createHigherOrderComponent( ( BlockListBlock ) => {
	return ( props ) => {
		if ( props.name !== 'core/query' ) {
			return <BlockListBlock { ...props } />;
		}

		props.wrapperProps = {
			...props.wrapperProps,
			'data-ghubqueryid': props.attributes.ghubQueryId,
		};
		return <BlockListBlock { ...props } { ...props.wrapperProps } />;
	};
}, 'withBlockWrapper' );

addFilter(
	'editor.BlockListBlock',
	'ghub-gallery-lightbox/with-block-wrapper',
	withBlockWrapper
);

addFilter(
	'editor.BlockEdit',
	'ghub-query-taxonomy/with-advance-controls',
	withAdvanceControls
);

addFilter(
	'blocks.registerBlockType',
	'ghub-query-taxonomy/add-attributes',
	addAttributes
);
